// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.calendar-view {
  /* border: 1px solid grey;
  border-radius: 3px;
  color: #EFEFEF;
  background-color: #303437;
  opacity: .8;
  box-shadow: 4px 4px 10px grey;
  width: 250px;
  padding: 10px;
  margin: 0 auto;
  text-align: center;
  */  
}

.calendar-view ul {
  list-style: none;
}

.calendar-card {
    background-color: #e6e3e3;
    width: 90%;
    max-width: 40rem;
/*    min-height: 40rem;   */
/*    margin: 5rem auto;   */ 
    display: grid;
/*    grid-template-rows: 8rem auto 10rem; */
    box-shadow: 0 1rem 1.5rem #bfbcb4;
    padding : 10px;
/*
    font-size: 10px;
    font-family: sans-serif;
    font-size: 1.5rem;    

*/
/*    line-height: 1.6;    */
}

.card__header {
  padding: 0;
  margin: 0;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: top;
  text-align: center;  
}

.card__body {
  padding: 0;
  margin: 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;  
}

.card__body--days {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 2rem;  
}

.card__body--days li {
                flex: 1;
                font-weight: normal;
                text-transform: uppercase;
                text-align: center;
                margin: 0 1px;
}

.card__body--dates {
  padding: 0 0 5px 0px;
  margin: 0;  
  display: grid;
  gap: 3px;
  grid-template-columns: repeat(7, 1fr);
  justify-items: center;
  text-align: center;
}

.card__body--dates li {
                width: 2.0rem;
                height: 2.0rem;
                display: grid;
                place-items: center;
                font-weight: normal;
                position: relative;
                border-radius: 50%;
}

li.card__body--dates.current-day {
  border: 2px solid;
  background: #0e0278;
  color: white;
}


#eventslink {
  font-size: 14px;
  color: #1E90FF;
  cursor: pointer;
}

#eventslink:hover {
  text-decoration: underline;
}

#addmonth {
  padding: 5px;
  width: 10px;
  float: left;
  cursor: pointer;
}

#month {
  padding: 5px;
  width: 200px;
  float:left;
}

#submonth {
  padding: 5px;
  width: 10px;
  float: left;
  cursor: pointer;
}

.days div {
  float: left;
  width: 25px;
  height: 25px;
  padding: 5px;
}

.current-day {
  color: orange;
  font-weight: bold;
}

.weeks {
  clear: both;
}

.weeks div {
  float: left;
  width: 25px;
  height: 25px;
  /*padding: 5px;*/
  padding: 2px 5px 2px 5px;
  cursor: pointer;
}

.clear {
  clear: both;
}

.ae {
  padding: 5px;
  text-align: left;
}

.aetitle {
  font-size: 14px;
}

#de {
  padding: 0 5px 0 5px;
  text-align: left;
}

.detitle {
 font-size: 14px;
}

input[type=text]
{
  width: 202px;
}

.eventday {
  width: 100%;
  padding-top: 7px;
  border-bottom: 1px solid #666666;
}

.textleft {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./client/javascript/common/calendarView.css"],"names":[],"mappings":";AACA;EACE;;;;;;;;;;GAUC;AACH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB,4BAA4B;AAC5B,4BAA4B;IACxB,aAAa;AACjB,4CAA4C;IACxC,iCAAiC;IACjC,cAAc;AAClB;;;;;CAKC;AACD,4BAA4B;AAC5B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;gBACgB,OAAO;gBACP,mBAAmB;gBACnB,yBAAyB;gBACzB,kBAAkB;gBAClB,aAAa;AAC7B;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,QAAQ;EACR,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;gBACgB,aAAa;gBACb,cAAc;gBACd,aAAa;gBACb,mBAAmB;gBACnB,mBAAmB;gBACnB,kBAAkB;gBAClB,kBAAkB;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["\n.calendar-view {\n  /* border: 1px solid grey;\n  border-radius: 3px;\n  color: #EFEFEF;\n  background-color: #303437;\n  opacity: .8;\n  box-shadow: 4px 4px 10px grey;\n  width: 250px;\n  padding: 10px;\n  margin: 0 auto;\n  text-align: center;\n  */  \n}\n\n.calendar-view ul {\n  list-style: none;\n}\n\n.calendar-card {\n    background-color: #e6e3e3;\n    width: 90%;\n    max-width: 40rem;\n/*    min-height: 40rem;   */\n/*    margin: 5rem auto;   */ \n    display: grid;\n/*    grid-template-rows: 8rem auto 10rem; */\n    box-shadow: 0 1rem 1.5rem #bfbcb4;\n    padding : 10px;\n/*\n    font-size: 10px;\n    font-family: sans-serif;\n    font-size: 1.5rem;    \n\n*/\n/*    line-height: 1.6;    */\n}\n\n.card__header {\n  padding: 0;\n  margin: 0;\n  color: black;\n  display: flex;\n  justify-content: space-between;\n  align-items: top;\n  text-align: center;  \n}\n\n.card__body {\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;  \n}\n\n.card__body--days {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 2rem;  \n}\n\n.card__body--days li {\n                flex: 1;\n                font-weight: normal;\n                text-transform: uppercase;\n                text-align: center;\n                margin: 0 1px;\n}\n\n.card__body--dates {\n  padding: 0 0 5px 0px;\n  margin: 0;  \n  display: grid;\n  gap: 3px;\n  grid-template-columns: repeat(7, 1fr);\n  justify-items: center;\n  text-align: center;\n}\n\n.card__body--dates li {\n                width: 2.0rem;\n                height: 2.0rem;\n                display: grid;\n                place-items: center;\n                font-weight: normal;\n                position: relative;\n                border-radius: 50%;\n}\n\nli.card__body--dates.current-day {\n  border: 2px solid;\n  background: #0e0278;\n  color: white;\n}\n\n\n#eventslink {\n  font-size: 14px;\n  color: #1E90FF;\n  cursor: pointer;\n}\n\n#eventslink:hover {\n  text-decoration: underline;\n}\n\n#addmonth {\n  padding: 5px;\n  width: 10px;\n  float: left;\n  cursor: pointer;\n}\n\n#month {\n  padding: 5px;\n  width: 200px;\n  float:left;\n}\n\n#submonth {\n  padding: 5px;\n  width: 10px;\n  float: left;\n  cursor: pointer;\n}\n\n.days div {\n  float: left;\n  width: 25px;\n  height: 25px;\n  padding: 5px;\n}\n\n.current-day {\n  color: orange;\n  font-weight: bold;\n}\n\n.weeks {\n  clear: both;\n}\n\n.weeks div {\n  float: left;\n  width: 25px;\n  height: 25px;\n  /*padding: 5px;*/\n  padding: 2px 5px 2px 5px;\n  cursor: pointer;\n}\n\n.clear {\n  clear: both;\n}\n\n.ae {\n  padding: 5px;\n  text-align: left;\n}\n\n.aetitle {\n  font-size: 14px;\n}\n\n#de {\n  padding: 0 5px 0 5px;\n  text-align: left;\n}\n\n.detitle {\n font-size: 14px;\n}\n\ninput[type=text]\n{\n  width: 202px;\n}\n\n.eventday {\n  width: 100%;\n  padding-top: 7px;\n  border-bottom: 1px solid #666666;\n}\n\n.textleft {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
